export default "__VITE_ASSET__A3ldVw1l__"